import {
  combineReducers,
  configureStore,
  getDefaultMiddleware,
} from "@reduxjs/toolkit";
import storage from "reduxjs-toolkit-persist/lib/storage";
import autoMergeLevel1 from "reduxjs-toolkit-persist/lib/stateReconciler/autoMergeLevel1";
import {
  persistCombineReducers,
  persistReducer,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
  persistStore,
} from "reduxjs-toolkit-persist";

// Slices
import userProfileSlice, {
  update as userProfileUpdate,
  initialState as userProfileInitialState,
} from "./slice/Account/user-profile.slice";
import tokenSlice, {
  update as tokenUpdate,
  initialState as tokenInitialState,
} from "./slice/Token/token.slice";
import companySlice from "./slice/Account/company.slice";
import inventorySlice from "./slice/Account/inventory.slice";
import jobSlice from "./slice/Account/job.slice";
import dropoffSlice from "./slice/Account/dropoff.slice";

const blacklist = ["userProfile"];

const persistConfig = {
  key: "root",
  timeout: 2000,
  storage: storage,
  stateReconciler: autoMergeLevel1,
  // blacklist,
};

const _persistedReducer = persistCombineReducers(persistConfig, {
  userProfile: userProfileSlice,
  token: tokenSlice,
  company: companySlice,
  inventory: inventorySlice,
  job: jobSlice,
  dropoff: dropoffSlice,
});

export const store = configureStore({
  reducer: _persistedReducer,
  middleware: getDefaultMiddleware({
    serializableCheck: {
      /* ignore persistance actions */
      ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
    },
  }),
});

export const persistor = persistStore(store);

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch;

export const destroyAllState = () => {
  store.dispatch(userProfileUpdate(userProfileInitialState));
  store.dispatch(tokenUpdate(tokenInitialState));
};
